import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { getBlogPostBySlug } from '../articles';
import SEO from './SEO';
import './BlogPost.css';

const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogPostBySlug(slug) : null;

  if (!post) {
    return (
      <div className="blog-post-not-found">
        <h2>Blog Post Not Found</h2>
        <p>The blog post you're looking for doesn't exist.</p>
        <Link to="/blog" className="back-to-blog">← Back to Blog</Link>
      </div>
    );
  }

  // Extract the first image from markdown content if available
  const imageMatch = post.content.match(/!\[.*?\]\((.*?)\)/);
  const rawImageUrl = imageMatch ? imageMatch[1] : undefined;
  const previewImage = rawImageUrl
    ? (/^https?:\/\//i.test(rawImageUrl) ? rawImageUrl : `${window.location.origin}${rawImageUrl}`)
    : undefined;
  const postUrl = `${window.location.origin}/blog/${post.slug}`;

  return (
    <div className="blog-post-page">
      <SEO 
        title={`${post.title} | Sourov Roy`}
        description={post.excerpt}
        image={previewImage}
        url={postUrl}
        type="article"
      />
      <div className="blog-post-container">
        <Link to="/blog" className="back-to-blog">← Back to Blog</Link>
        
        <article className="blog-post-full">
          <header className="post-header">
            <h1 className="post-title">{post.title}</h1>
            <div className="post-meta">
              <span className="post-author">By {post.author}</span>
              <div className="post-meta-group">
                <span className="post-date">{post.date}</span>
                <span className="post-read-time">{post.readTime}</span>
              </div>
            </div>
          </header>
          
          <div className="post-content">
            <p className="post-excerpt">{post.excerpt}</p>
            <div className="post-body">
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>{post.content}</ReactMarkdown>
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
